// src/components/ui/CrashFallback.jsx
// Single job: the two render-crash fallbacks (spec 2026-09-26-app-error-boundary-design.md).
// Presentational only: no hooks, no data props, fixed JT tokens and fixed copy, so a fallback
// can never crash on the data that crashed the page. Never renders the error itself.
// Neutral colors on purpose: red means a losing slip (Signal Scarcity); a crash is not a loss.
// No platform/native imports: AppCrashScreen's Reload side effect is injected by the caller
// (AppRoot) via onReload, so this file -- reachable from App.js's own module graph via
// TabCrashCard -- never pulls lib/platform.js (and its @capacitor/camera import) in.
import { JT } from "./jumbotronTokens";

const CARD = { background: JT.bg.card, border: `1px solid ${JT.border.mid}`, borderRadius: JT.radius.card, padding: 24, textAlign: "center" };
const TITLE = { fontSize: 18, fontWeight: 700, lineHeight: 1.4, color: JT.text.primary, marginBottom: 6 };
const BODY = { fontSize: 14, fontWeight: 500, lineHeight: 1.5, color: JT.text.secondary, marginBottom: 16 };
const GHOST = { background: "none", border: `1px solid ${JT.border.mid}`, color: JT.text.body, borderRadius: 12, fontSize: 14, fontWeight: 700, padding: "0 20px", minHeight: 44, minWidth: 44, cursor: "pointer", fontFamily: "inherit" };
// DESIGN.md button-primary: the one CTA on the screen (Reload is the only way out).
const PRIMARY = { background: "linear-gradient(135deg,#1d4ed8,#4f46e5)", boxShadow: JT.brand.ctaShadow, border: "none", color: JT.text.primary, borderRadius: 12, fontSize: 15, fontWeight: 700, padding: "0 32px", minHeight: 48, minWidth: 44, cursor: "pointer", fontFamily: "inherit" };

export function TabCrashCard({ onRetry }) {
  return (
    <div style={{ padding: "16px 20px" }}>
      <div role="alert" style={CARD}>
        <div style={TITLE}>This tab hit a problem.</div>
        <div style={BODY}>It's been reported. Try again, or switch tabs.</div>
        <button type="button" onClick={onRetry} style={GHOST}>Try again</button>
      </div>
    </div>
  );
}

export function AppCrashScreen({ onReload }) {
  // No card: a lone boxed card on an empty screen is the lazy answer (DESIGN.md / impeccable).
  return (
    <div style={{ height: "100dvh", boxSizing: "border-box", background: JT.bg.root, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'SF Pro Display','DM Sans',system-ui,sans-serif", maxWidth: 480, margin: "0 auto", paddingTop: "env(safe-area-inset-top)" }}>
      <div role="alert" style={{ width: "100%", boxSizing: "border-box", padding: "0 32px", textAlign: "center" }}>
        <div style={{ ...JT.type.label, color: JT.text.tertiary, marginBottom: 14 }}>SlipTrack</div>
        <div style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.2, letterSpacing: "-0.3px", color: JT.text.primary, marginBottom: 10 }}>Something went wrong.</div>
        <div style={{ ...BODY, maxWidth: "34ch", margin: "0 auto 24px" }}>SlipTrack hit an unexpected error and it's been reported. Reload to get back to your slips.</div>
        <button type="button" onClick={onReload} style={PRIMARY}>Reload</button>
      </div>
    </div>
  );
}
